import React, {PropsWithChildren} from 'react';
import {observer} from 'mobx-react';
import {useLocation, useNavigate, Outlet} from 'react-router-dom';
import {useViewController} from 'data/services/locator';
import {Bindings} from 'data/constants/bindings';
import type {IGigyaGateController} from 'views/components/gigya_gate/gigya_gate.controller';
import {PagePreloader} from 'views/components/preloader';

export const GigyaGate: React.FC<PropsWithChildren> = observer(({children}) => {
	const {isSessionChecked} = useViewController<IGigyaGateController>(
		Bindings.GigyaGateController,
		{
			location: useLocation(),
			navigate: useNavigate(),
		}
	);

	return isSessionChecked ? <Outlet/> : <PagePreloader />;
});
